
import { Options, prop, Vue } from "vue-class-component";
import ScheduleConfigSkeleton from "./ScheduleConfigSkeleton.vue";

class Props {
  loading = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  components: {
    ScheduleConfigSkeleton
  }
})
export default class CardLayout extends Vue.with(Props) {}
